



























export default {
  name: "PagedItems",
  props: {
    totalItemCount: Number
  },
  data() {
    return {
      currentPages: 1,
      shownItemCount: 0
    };
  },
  created() {
    this.shownItemCount = this.perPage;
  },
  watch: {
    perPage(newValue, oldValue) {
      if (newValue != oldValue) {
        this.shownItemCount = newValue;
        this.updateParentList();
      }
    },
    currentPages(newValue, oldValue) {
      this.updateParentList();
      setTimeout(() => {
        this.focusPagination();
      }, 100);
    }
  },
  computed: {
    perPage() {
      return this.$store.getters.getPerPage;
      //get preference from user from coockie/store (opslaan preference per lijst of algemeen)
    }
  },
  methods: {
    updateParentList() {
      this.$emit("updateList", this.getShownRange());
    },

    focusPagination() {
      window.scroll(0, this.findPos(document.getElementById("topbar")));
    },

    //Finds y value of given object
    findPos(obj) {
      var curtop = 0;
      if (obj && obj.offsetParent) {
        do {
          curtop += obj.offsetTop;
        } while ((obj = obj.offsetParent));
        return [curtop - 500];
      }
    },

    getShownItemCount() {
      return this.shownItemCount > this.totalItemCount
        ? this.totalItemCount
        : this.shownItemCount;
    },

    getShownRange() {
      var mark = this.currentPages * this.perPage - this.perPage;
      return [mark, mark + this.perPage];
    },

    getPlusItemCount() {
      return this.perPage + this.getShownItemCount() < this.totalItemCount
        ? this.perPage
        : this.totalItemCount - this.getShownItemCount();
    },

    totalPagesCount() {
      return Math.ceil(this.totalItemCount / this.perPage);
    },

    showMore() {
      this.currentPages++;
      this.shownItemCount += this.perPage;
      this.updateParentList();
      //this.shouldResize = true;
    },

    showAll() {
      this.currentPages = this.totalItemCount / this.perPage + 1;
      this.updateParentList();
      //this.shouldResize = true;
    }
  }
};
